import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { scrollClass } from '../Scroll/styles';
import { compareColumns } from '../utils/shallowEqual';
import { Component } from '../component';
export default (function (Table) {
  var _temp;

  return _temp =
  /*#__PURE__*/
  function (_Component) {
    _inherits(AutoFixed, _Component);

    var _super = _createSuper2(AutoFixed);

    function AutoFixed(props) {
      var _this;

      _classCallCheck(this, AutoFixed);

      _this = _super.call(this, props);
      _this.wrapper = void 0;
      _this.state = {
        fixed: null
      };
      _this.bindWrapper = _this.bindWrapper.bind(_assertThisInitialized(_this));
      _this.resetAutoFixedState = _this.resetAutoFixedState.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(AutoFixed, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _this2 = this;

        var diff = ['fixed', 'width', 'height', 'data'].find(function (k) {
          return _this2.props[k] && prevProps[k] !== _this2.props[k];
        });
        var reset = !compareColumns(prevProps.columns, this.props.columns) || diff;

        if (reset) {
          // eslint-disable-next-line react/no-did-update-set-state
          this.setState({
            fixed: null
          });
        }
      }
    }, {
      key: "getFixed",
      value: function getFixed() {
        if (this.state.fixed !== null) return this.state.fixed;
        if (this.props.fixed === 'auto') return 'both';
        return this.props.fixed;
      }
    }, {
      key: "bindWrapper",
      value: function bindWrapper(wrapper) {
        this.wrapper = wrapper;
      }
    }, {
      key: "resetFixed",
      value: function resetFixed() {
        if (!this.wrapper) return;
        var verticalHandle = this.wrapper.querySelector(".".concat(scrollClass('y'), ".").concat(scrollClass('show')));
        var horizontalHandle = this.wrapper.querySelector(".".concat(scrollClass('x'), ".").concat(scrollClass('show')));
        if (verticalHandle && horizontalHandle) return;
        var fixed;
        if (horizontalHandle) fixed = 'x';else if (verticalHandle) fixed = 'y';
        this.setState({
          fixed: fixed
        });
      }
    }, {
      key: "fixedAuto",
      value: function fixedAuto() {
        if (this.props.fixed !== 'auto' || this.state.fixed !== null) return;
        this.resetFixed();
      }
    }, {
      key: "resetAutoFixedState",
      value: function resetAutoFixedState() {
        this.setState({
          fixed: null
        });
      }
    }, {
      key: "render",
      value: function render() {
        var fixed = this.getFixed();
        setTimeout(this.fixedAuto.bind(this));
        return (
          /*#__PURE__*/
          React.createElement(Table, Object.assign({}, this.props, {
            fixed: fixed,
            bindWrapper: this.bindWrapper,
            resetFixAuto: this.resetAutoFixedState
          }))
        );
      }
    }]);

    return AutoFixed;
  }(Component), _temp;
});